import { CheckboxCard } from "shared/components/forms/CheckboxCard";

export const RadioPreview = ({
  options,
  selected,
  onSelect
}: {
  options: string[];
  selected: string;
  onSelect: (value: string) => void;
}) => {
  return (
    <div className="flex flex-col gap-2 w-full">
      {options.map((opt) => (
        <CheckboxCard
          key={opt}
          id={`preview-radio-${opt}`}
          name="radio-preview"
          checked={selected === opt}
          onChange={() => onSelect(opt)}
          label={opt}
          wrapperClassName="w-full"
        />
      ))}
    </div>
  );
};
